import {
  ContentTypeEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import CaseGrid from '../../components/CaseGrid';
import { BlockInstanceProps } from '../Block';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  { key: 'showNumbering', definition: controlOptionDefinitions.boolean },
  {
    key: 'seoWeight',
    definition: controlOptionDefinitions.SEOWeightTypes,
  },
])
class CaseGridBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const showNumbering = controlOptions?.showNumbering;
    const seoWeight = controlOptions?.seoWeight;

    let mediaItems;
    blockContent.doQuery((content) => {
      mediaItems = content.getAllOfType(ContentTypeEnum.MEDIAITEM);
    });

    return (
      <CaseGrid
        items={mediaItems}
        backgroundColor={backgroundColor}
        showNumbering={showNumbering}
        seoWeight={seoWeight}
      />
    );
  }
}

export default CaseGridBlock;
